import { isSSR } from "./is-ssr";

export function isWebOS(): boolean {
  if (isSSR()) {
    return false;
  }
  return "webos" in window;
}
